<h1 mat-dialog-title class="col-12 dialogTitle">{{data.dialogTitle}}</h1>

<mat-form-field class="col-12">
  <input matInput [(ngModel)]="data.name" placeholder="Name">
</mat-form-field>
<mat-form-field class="col-12">
  <textarea matInput [(ngModel)]="data.descriptionText" placeholder="Description" cdkTextareaAutosize class="textArea"></textarea>
</mat-form-field>

<div class="col-12 mb-3">
  <mat-dialog-actions align="end">
    <button class="dialog-protection-typeCancelButton" mat-raised-button (click)="onClickCancel()">Cancel</button>
    <button class="dialog-protection-typeSaveButton" mat-raised-button color="primary" [mat-dialog-close]="data" cdkFocusInitial>Ok</button>
  </mat-dialog-actions>
</div>
